import type { FaireProductEntity } from "../../entity_types/product";

export const p_gu8nn48x6z: FaireProductEntity = {
  token: "p_gu8nn48x6z",
  type: "product",
  name: "Popcorn, Soy Butter",
  brandToken: "b_vfzpdjf7u9",
  brandName: "Pom Pom Popcorn by Bessou",
  imageUrl:
    "https://cdn.faire.com/fastly/33fdeff7f8ca61c2045676759eaf3f42ae498a2e5dc7bef9af96c719d489402f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc28c8fcb965dbe0e99743fe422b2cfee89f5a3758908b026a59a4036bbef754.jpeg",
    "https://cdn.faire.com/fastly/23b72682398c8e12b6a2d6a2b04b722f82c5dfccd68e6dc7bb42726e17831196.png",
    "https://cdn.faire.com/fastly/d1ae29861e07accefb85ff40a295662fb152e6da94c3037f9858215adbb748b8.png",
    "https://cdn.faire.com/fastly/a3bcf2d6622cf05e042a8bd20519b0737a7fadd683cccaaa57fa9b1503df1a67.png",
    "https://cdn.faire.com/fastly/1cb669e6b53b32279aca4b7617f870bd8c7176af218c9f215423ccb313d21209.png",
  ],
  priceDollars: 3.75,
  description:
    "Soy Butter: Deep savory soy sauce and rich creamy butter make for the ultimate umami-rich combo.\n\nAbout Pom Pom Popcorn:\nPom Pom Popcorn was first created at Bessou, my Japanese American eatery in NYC. We wanted to share the delicious flavors of Japan using the most iconic American snack: popcorn! Taking our favorite childhood treats as inspiration, we use real ingredients in everything and make our popcorn in small batches so you can taste the love, care and flavor in every bite. The result is delightful, healthier snacking. Arigato!",
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:16.314Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
